<template>
	<div id="title-screens" class="screen title-screens">
		<div class="screen-container">
			<GeneralHeader />
			<main>
				<router-view/>
			</main>
			<GeneralFooter>
				<img id="approved-sept-21" width="142" src="../assets/title-screens/approved.png" />
			</GeneralFooter>
		</div>
	</div>
</template>
<script>
import GeneralHeader from '@/components/GeneralHeader'
import GeneralFooter from '@/components/GeneralFooter'
//import analyticsMixin from '@/mixins/Analytics.js'

export default {
//	mixins: [analyticsMixin],
	components: {
		GeneralHeader,
		GeneralFooter
	},
	mounted() {

	}
}
</script>
<style scoped>
#title-screens {
	overflow: hidden;
}
</style>
